import http from '@/utils/http'

export function getSetting(){
    return http(`/basic_informations`)
}
export function putSetting(id,data){
    return http.put(`/basic_informations/${id}`,data)
}
export function getEmailAccounts(){
    return http(`/email_accounts`)
}
export function addEmailAccount(data){
    return http.post(`/email_accounts`,data)
}
export function getEmailLogs(params){
    return http(`/email_logs`,{params})
}
export function getUserActivityLogs(params){
    return http(`/user_activity_logs`,{params})
}